import { buttonClasses, SxProps } from '@mui/material'

interface DateRangePickerHeaderStyles {
  wrapper: SxProps
  monthText: SxProps
  button: SxProps
}

export const dateRangePickerHeaderStyles: DateRangePickerHeaderStyles = {
  wrapper: { display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'space-between' },
  monthText: { typography: 'textSm', px: 1.5, py: 1 },
  button: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '.icon': {
      width: 10,
      height: 10,
      color: 'text.primary900',
    },
    [`&.${buttonClasses.disabled} .icon`]: {
      color: 'foreground.quinary400',
    },
  },
}
